<template>
    <section class="section">
        <div class="container">
            <router-view></router-view>
        </div>
    </section>
</template>

<script>
export default {

    created() {
        this.$store.dispatch('loadUsers')
    },
}
</script>
